<template>
  <div class="flex flex-col items-start gap-6">
    <router-link
      id="back-to-table-list-link"
      class="text-fg-link-primary flex items-center gap-2 text-sm"
      :to="{ name: PERFORMANCE_ROUTE_NAMES.TABLES }"
      replace
    >
      <ResArrowLeftIcon />
      <span>Back to Table List</span>
    </router-link>

    <SlotPanel classes="w-full">
      <BulkTablePrices
        v-model="selectedPricingTier"
        :uniquePrices="pricingTiers"
        @updatePrice="updateTablePrices"
        submitLabel="Apply"
        hideCancel
      />
    </SlotPanel>
  </div>
</template>

<script setup lang="ts">
import * as _ from 'lodash-es'
import { storeToRefs } from 'pinia'
import { computed, onBeforeMount, ref, watch } from 'vue'

import ResArrowLeftIcon from '@/assets/resArrowLeft.svg?component'
import SlotPanel from '@/common/components/organisms/SlotPanel.vue'
import BulkTablePrices from '@/components/BulkTablePrices.vue'
import { PERFORMANCE_ROUTE_NAMES } from '@/modules/performance/constants/PerformanceRouteConstants'
import { usePerformanceReservationStore } from '@/modules/performance/stores/PerformanceReservationStore'
import { usePerformanceUpdateStore } from '@/modules/performance/stores/PerformanceUpdateStore'

const performanceReservationStore = usePerformanceReservationStore()
const performanceUpdateStore = usePerformanceUpdateStore()
const { updatedPerformance } = storeToRefs(performanceUpdateStore)

const selectedPricingTier = ref<number | null>(null)
watch(selectedPricingTier, () => {
  if (!updatedPerformance.value?.tables || selectedPricingTier.value === null) return
  const tablesWithPricingTier = _.filter(updatedPerformance.value.tables, {
    price_per_person: selectedPricingTier.value.toFixed(2),
  })
  performanceReservationStore.setLowOpacityTableIds(
    _.difference(
      updatedPerformance.value.tables.map(table => table.id),
      tablesWithPricingTier.map(table => table.id),
    ),
  )
})
onBeforeMount(() => {
  performanceReservationStore.setLowOpacityTableIds([])
})

const pricingTiers = computed<number[]>(() => {
  if (!updatedPerformance.value?.tables) return []
  return _.uniq(updatedPerformance.value.tables.map(table => Number(table.price_per_person))).sort(
    (a, b) => a - b,
  )
})

function updateTablePrices(newPrice: number) {
  if (selectedPricingTier.value === null) return
  performanceUpdateStore.updateTablesByPrice(newPrice, selectedPricingTier.value)
  selectedPricingTier.value = newPrice
}
</script>
